<template lang="pug">
.card-dashboard(:class="[{'clickable': clickable }]" :style="{'color':color}" @click="clickCard")
  .title
    span {{title}}
  .content(:style="{'marginTop': this.marginTop}")
    span.text {{content}}
    i(v-if="icon" :class="icon")
    img(v-if="image" :src="image")
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      required: true
    },
    clickable: {
      type: Boolean,
      default: false
    },
    icon: {
      default: null
    },
    image: {
      default: null
    },
    color: {
      default: 'black'
    },
    marginTop: {
      default: 20
    }
  },

  methods: {
    clickCard () {
      this.$emit('clickCard')
    }
  }
}

</script>

<style lang="scss" scoped>
.card-dashboard {
  display: flex;
  justify-content: space-between;
  border: 2px solid;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0px 3px 6px #00000029;
  margin-left: 20px;
  margin-bottom:20px;
  flex-wrap: wrap;
  flex-basis: 100%;
}

.title {
  font-size: 18px;
  color: #8D8D8D;
  padding-bottom: 5px;
}

.text {
  font-size: 30px;
  font-weight: bold;
  color:dimgray;
}

.content {
  display: flex;
  justify-content: space-between;
  width:100%;
  align-items: flex-end;
  margin-top:20px;
}

.clickable {
  cursor: pointer;
}

i {
  font-size:40px;
  margin-left: 20px;
}

img {
  height: 40px;
  width: 40px;
}

</style>



// WEBPACK FOOTER //
// src/components/AppCardDashboard.vue